var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76055 13.3856L10.6355 6.51062C10.7322 6.41406 10.8633 6.35983 10.9999 6.35983C11.1366 6.35983 11.2676 6.41406 11.3643 6.51062L18.2393 13.3856C18.3304 13.4834 18.38 13.6127 18.3776 13.7462C18.3752 13.8798 18.3211 14.0073 18.2267 14.1017C18.1322 14.1962 18.0047 14.2503 17.8712 14.2527C17.7376 14.255 17.6083 14.2055 17.5105 14.1144L10.9999 7.60461L4.4893 14.1144C4.39155 14.2055 4.26227 14.255 4.12869 14.2527C3.99511 14.2503 3.86765 14.1962 3.77318 14.1017C3.67871 14.0073 3.6246 13.8798 3.62224 13.7462C3.61988 13.6127 3.66947 13.4834 3.76055 13.3856Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.e1645696852bea5afd271cef2b95990e.svg";
export { ForwardRef as ReactComponent };